import React from 'react';

import Alert from 'components/Alert';
import { constants } from 'helpers/constants';

export default class Blinket {
  public static isBlinket = (partnerId: number) => partnerId === constants.productPartners.blinket;

  public static blinketModal = async () => {
    const confirm = await Alert.confirm({
      message: 'Essa configuração deve ser feita na Blinket. Deseja continuar?',
      title: 'Produto Blinket',
      confirmation: true,
      buttonOk: <>Ir para a Blinket</>,
      buttonCancel: <>Cancelar</>
    });

    if (confirm) Blinket.openBlinket();
  };

  public static openBlinket = () => window.open('https://app.blinket.com.br', '_blank');
}
